import controller from './comments.controller';
import template from './comments.html';
import './comments.scss';

export default {
	template,
	bindings: {
		disabled:    '<?ngDisabled',
		contexts:    '=ngModel',
		node:        '=?',
		options:     '=?',
	},
	controller,
	require:  {
		kformCtrl:   '^^?kform',
		ngModelCtrl: 'ngModel',
	},
};
